<template>
<div>
  <v-card>
    <v-card-title>
      <h4 class="display-12 white--text font-weight-light">Choose your challenge</h4>
    </v-card-title>
  <v-container id="dropdown-example" grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 sm4
      >
        <p class="text-md-center">Frequency</p>
        <v-overflow-btn
          :items="dropdown_frequency"
          item-value="value"
          label="Choose frequency..."
          target="#dropdown-example"
          slot="activator"
          mandatory
          v-model="dropdown_frequency.value"
        ></v-overflow-btn>
      </v-flex>

      <v-flex xs12 sm4>
        <p class="text-md-center">Duration</p>
        <v-overflow-btn
          :items="dropdown_duration"
          item-value="value"
          label="Choose duration..."
          target="#dropdown-example"
          slot="activator"
          mandatory
          v-model="dropdown_duration.value"
        ></v-overflow-btn>
      </v-flex>

      <v-flex xs12 sm4>
        <p class="text-md-center">Goal</p>
        <v-overflow-btn
          :items="dropdown_goal"
          item-value="value"
          label="Choose goal..."
          target="#dropdown-example"
          slot="activator"
          mandatory
          v-model="dropdown_goal.value"
        ></v-overflow-btn>
      </v-flex>
    </v-layout>
  </v-container>
  </v-card>
 <!-- <h3 class="text-xs-center titles">Your challenge</h3>
<p class="text-xs-center">{{ dropdown_frequency.value }}</p>
<p class="text-xs-center">{{ dropdown_duration.value }}</p>
<p class="text-xs-center">{{ dropdown_goal.value }}</p>
</v-card>
<v-card> -->
          <!-- <h2 class="text-xs-center titles">Your challenge</h2>
        <v-container>
          <v-layout row wrap>
              <p class="text-xs-center">Frequency: {{ dropdown_frequency.value }} </p>
              <v-spacer></v-spacer>
              <p class="text-xs-center">Duration: {{ dropdown_duration.value }} </p>
              <v-spacer></v-spacer>
              <p class="text-xs-center">Goal: {{ dropdown_goal.value }} </p>
          </v-layout>
        </v-container> -->
  <div class="text-right">
        <v-btn :disabled='isDisabled' type="submit">SUBMIT</v-btn>
        </div>
   <v-spacer></v-spacer>
   <v-card>
<v-toolbar>
      <v-toolbar-title class="display-12 white--text font-weight-light">Customize</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
         <template v-slot:activator="{ on }">
           <v-btn class="ma-2" outlined fab small color="white" v-on="on" icon>
      <v-icon color="white">add</v-icon>
    </v-btn>
    </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 lg6>
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedDateFormattedMomentjs"
                          clearable
                          v-model="editedItem.name"
                          label="Schedule Day"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                        <v-date-picker
                          v-model="date"
                          @change="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                      </v-flex>
                    <v-text-field v-model="editedItem.amount" label="Amount"></v-text-field>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    </v-card>
    <v-card>
    <v-data-table
      :headers="headers"
      :items="amounts"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.amount }}</td>
        <td class="justify-center layout px-0">
          <v-icon small right class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)">
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    </v-card>
     </div>
</template>
<script>
import moment from 'moment'
import format from 'date-fns/format'

export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    // items: [
    //   { text: 'Amount', disabled: true, href: 'breadcrumbs_dashboard' },
    //   { text: 'Duration', disabled: true, href: 'breadcrumbs_link_1' },
    //   { text: 'Schedule', disabled: true, href: 'breadcrumbs_link_2' }
    // ],
    dropdown_frequency: [ { text: 'Daily', value: 'Daily' },
      { text: 'Bi-Weekly', value: 'Bi-Weekly' },
      { text: 'Weekly', value: 'Weekly' }
    ],
    dropdown_duration: [
      { text: '6 Months', value: '6 Months' },
      { text: '1 Year', value: '1 Year' },
      { text: '2 Years', value: '2 Years' },
      { text: '3 Years', value: '3 Years' }
    ],
    dropdown_goal: [
      { text: '1000', value: '1000' },
      { text: '2000', value: '2000' },
      { text: '2500', value: '2500' },
      { text: '3000', value: '3000' },
      { text: '3500', value: '3500' }
    ],
    dialog: false,
    headers: [
      { text: 'Schedule', value: 'name', sortable: false },
      { text: 'Amount', value: 'amount', sortable: false },
      { text: 'Edit/Delete', value: '', sortable: false }
    ],
    amounts: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      amount: 0
    },
    defaultItem: {
      name: '',
      amount: 0
    },
    enable: false
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Amount' : 'Edit Amount'
    },
    isDisabled: function () {
      return !this.enable
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },
  computedDateFormattedMomentjs () {
    return this.date ? moment(this.date).format('dddd, MMMM Do YYYY') : ''
  },
  computedDateFormattedDatefns () {
    return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
  },

  methods: {
    initialize () {
      this.amounts = [
        {
          name: 'Day 1',
          amount: 0
        }
      ]
    },

    //  async openContestEntriesDialog (scheduleItem) {
    // this.loadingContestEntries = true
    // var endpoint = `${
    //   process.env.VUE_APP_QUBER_SERVICE_REWARDS
    // }/contest-schedule/${scheduleItem.id}/entries`
    // var getResponse = await rh.default.get(endpoint, true).catch(e => {
    //   this.errors.push(e)
    // })

    // this.contestEntries = getResponse.data
    // this.loadingContestEntries = false
    // this.contestEntriesDialog = true
    // },

    editItem (item) {
      this.editedIndex = this.amounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.amounts.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.amounts.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.amounts[this.editedIndex], this.editedItem)
      } else {
        this.amounts.push(this.editedItem)
      }
      this.close()
    },

    frequency: function () {
      var frequency = dropdown_frequency.value
      if (frequency === 'Daily') {
        if (frequency === 'Weekly') {
          if (frequency === 'Bi-Weekly') {
            return frequency
          } else {
            // return console.log('This didnt work')
          }
        }
      }
    },
    duration: function () {
      var duration = dropdown_duration.value
      if (duration === '6 Months') {
        if (duration === '1 Year') {
          if (duration === '2 Years') {
            if (duration === '3 Years') {
              return duration
            } else {
              // return console.log('This didnt work')
            }
          }
        }
      }
    },
    goal: function () {
      var goal = dropdown_frequency.goal
      if (goal === '1000') {
        if (goal === '2000') {
          if (goal === '2500') {
            if (goal === '3000') {
              if (goal === '3500') {
                return goal
              } else {
                // return console.log('This didnt work')
              }
            }
          }
        }
      }
    }
  }
}
</script>
<style>

.v-card {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

 h3 {
    display: block;
  font-size: 1em;
  margin-top: 0.67em;
  margin-bottom: 0.67em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
  font-family: Oxygen;
  align-content: center;
 }

 p {
   align-content: center;
   display: block;
   margin-top: 1em;
   margin-bottom: 1em;
   margin-left: 0;
   margin-right: 0;
 }
 .titles {
   font-size: 20px;
   font-weight: light;
   font-family: Oxygen;
 }

 .preview {
   margin: 10px 10px 20px 20px;
 }

</style>
